import {Opt} from 'ts-opt';

import {NavigationRestriction} from 'app/navigation';

/**
 * Checks whether the current user can access a restricted route.
 *
 * @param currentUserPermissions Current user permissions, if loaded.
 * @param currentPathRestriction Route restriction for the active path.
 * @returns `true` when the user can enter the route.
 *
 * @example
 * userHasAccessComputation(opt(['USER_PROFILE']), {path: '/profil-uzivatele', permissions: ['USER_PROFILE']});
 */
export const userHasAccessComputation = (
    currentUserPermissions: Opt<Array<string>>,
    currentPathRestriction: NavigationRestriction | undefined,
): boolean => {
    const pathPermissions = currentPathRestriction?.permissions;

    // eslint-disable-next-line @fl/use-eta-reduction
    return !pathPermissions || currentUserPermissions.existsIn(p => pathPermissions.includes(p)).orFalse();
};
